export enum SupplierDocType {
	Invoice = 1,
	CreditNote = 2,
	DebitNote = 3,
	Statement = 4,
	GoodsReceivedNoteOnly = 5,
}

export enum SupplierDocTypeName {
	Invoice = "Invoice",
	CreditNote = "Credit Note",
	DebitNote = "Debit Note",
	Statement = "Statement",
}

export enum SupplierDocumentStepHistoryStatus {
	Completed = "Completed",
	Ready = "Ready",
	Pending = "Pending",
	Recalled = "Recalled",
	ChangeRequested = "Change Requested",
	Rejected = "Rejected",
	Deleted = "Deleted",
	Delegated = "Delegated",
	Escalated = "Escalated",
	Cancelled = "Cancelled",
}
